<div class="company-comparison">
  <div class="company-comparison__header">
    <span class="company-comparison__header__title">
      {{ 'COMPANY_COMPARISON.TITLE' | translate }}
    </span>

    <div class="company-comparison__header__page-buttons">
      <div class="company-comparison__header__page-buttons--expanded">
        <mat-slide-toggle (change)="autoRefresh($event)" [checked]="false">
          {{ 'COMPANY_COMPARISON.AUTO_RELOAD' | translate }}
        </mat-slide-toggle>

        <button
          [disabled]="isLoading"
          (click)="reload()"
          matTooltip="{{ 'COMPANY_COMPARISON.RELOAD' | translate }}"
          class="company-comparison__header__page-buttons--expanded__button"
        >
          <i
            class="angularjs-fuse-icon icon-reload company-comparison__header__page-buttons--expanded__button__icon"
          ></i>
        </button>

        <button
          *ngIf="isFilterOn"
          matTooltip="{{ 'COMPANY_COMPARISON.FILTER_CLEAR' | translate }}"
          [disabled]="isLoading"
          class="company-comparison__header__page-buttons--expanded__button"
          (click)="clearFilters()"
        >
          <i
            class="angularjs-fuse-icon icon-filter-remove company-comparison__header__page-buttons--expanded__button__icon"
          ></i>
        </button>

        <button
          *ngIf="selectedCompanies.length"
          matTooltip="{{ 'COMPANY_COMPARISON.COMPANY_CLEAR' | translate }}"
          [disabled]="isLoading"
          (click)="clearCompanies()"
          class="company-comparison__header__page-buttons--expanded__button"
        >
          <mat-icon class="company-comparison__header__page-buttons--expanded__button__icon">domain_disabled</mat-icon>
        </button>
      </div>

      <div class="company-comparison__header__page-buttons--collapsed">
        <button
          class="company-comparison__header__page-buttons--collapsed__arrow-button"
          [matMenuTriggerFor]="menuCompanyComparasion"
        >
          <mat-icon>keyboard_arrow_down</mat-icon>
        </button>

        <mat-menu #menuCompanyComparasion>
          <button
            class="company-comparison__header__page-buttons--collapsed__button"
            mat-menu-item
            [disabled]="isLoading"
            (click)="reload()"
          >
            <i class="angularjs-fuse-icon icon-reload"></i>
            <span>{{ 'COMPANY_COMPARISON.RELOAD' | translate }}</span>
          </button>

          <button
            *ngIf="isFilterOn"
            class="company-comparison__header__page-buttons--collapsed__button"
            mat-menu-item
            [disabled]="isLoading"
            (click)="clearFilters()"
          >
            <i class="angularjs-fuse-icon icon-filter-remove"></i>
            <span>{{ 'COMPANY_COMPARISON.FILTER_CLEAR' | translate }}</span>
          </button>

          <button
            *ngIf="selectedCompanies.length"
            class="company-comparison__header__page-buttons--collapsed__button"
            mat-menu-item
            [disabled]="isLoading"
            (click)="clearCompanies()"
          >
            <mat-icon>domain_disabled</mat-icon>
            <span>{{ 'COMPANY_COMPARISON.COMPANY_CLEAR' | translate }}</span>
          </button>
        </mat-menu>
      </div>
    </div>
  </div>

  <filter></filter>

  <div class="company-comparison__companies">
    <div (click)="openChooseCompaniesDialog()" class="company-comparison__companies__choose-companies">
      <div class="company-comparison__companies__choose-companies__content">
        <mat-icon class="company-comparison__companies__choose-companies__content__icon">search</mat-icon>
        <span class="company-comparison__companies__choose-companies__content__text">
          {{ 'COMPANY_COMPARISON.CHOOSE_COMPANIES' | translate: { quantity: selectedCompanies.length } }}
        </span>
      </div>
    </div>

    <div *ngFor="let company of selectedCompanies" class="company-comparison__companies__company">
      <div class="company-comparison__companies__company__close">
        <mat-icon
          [ngStyle]="{ 'pointer-events': isLoadingAllData || isLoading ? 'none' : 'auto' }"
          (click)="removeCompany(company.id)"
        >
          close
        </mat-icon>
      </div>
      <img
        *ngIf="company.avatarUrl"
        [src]="company.avatarUrl"
        [alt]="'COMPANY_COMPARISON.DIALOG.COMPANY_LOGO' | translate"
        (error)="company.avatarUrl = null"
        class="company-comparison__companies__company__logo"
      />
      <div *ngIf="!company.avatarUrl" class="company-comparison__companies__company--default-logo">
        <img
          src="assets/images/icons/mdi_office-building.svg"
          [alt]="'COMPANY_COMPARISON.DIALOG.COMPANY_LOGO' | translate"
          class="company-comparison__companies__company--default-logo__image"
        />
      </div>
      <div matTooltip="{{ company.name }}" class="company-comparison__companies__company__name">
        <span>{{ company.name }}</span>
      </div>
    </div>
  </div>

  <div *ngIf="selectedCompanies.length" class="company-comparison__tables">
    <ng-container *ngIf="!selectedCompaniesWithTableDataObjectStructureExample && isLoading">
      <div class="company-comparison__tables__table__header">
        <div [ngStyle]="{ 'grid-column': 'span ' + (selectedCompanies.length + 1) }">
          <ngx-skeleton-loader [theme]="{ width: '100%', height: '51px', margin: '0px' }"></ngx-skeleton-loader>
        </div>
      </div>
      <div class="company-comparison__tables__table__content">
        <ng-container *ngFor="let property of skeletonRowsQuantity">
          <div class="company-comparison__tables__table__content__row">
            <div *ngFor="let company of skeletonColumnsQuantityWhenNoDataLoaded">
              <ngx-skeleton-loader [theme]="{ width: '100%', height: '62px', margin: '0px' }"></ngx-skeleton-loader>
            </div>
          </div>
        </ng-container>
      </div>
    </ng-container>

    <ng-container *ngFor="let tableName of getObjectKeys(selectedCompaniesWithTableDataObjectStructureExample?.table)">
      <table class="company-comparison__tables__table">
        <thead class="company-comparison__tables__table__header">
          <tr
            [ngStyle]="{ 'grid-column': 'span ' + (selectedCompanies.length + 1) }"
            class="company-comparison__tables__table__header__title"
          >
            <th class="company-comparison__tables__table__header__title__text">
              {{ 'COMPANY_COMPARISON.STATUS.' + (tableName | changeCase: 'constantCase') + '.TITLE' | translate }}
            </th>
          </tr>
        </thead>
        <tbody class="company-comparison__tables__table__content">
          <ng-container
            *ngFor="
              let property of getObjectKeys(selectedCompaniesWithTableDataObjectStructureExample.table[tableName])
            "
          >
            <tr class="company-comparison__tables__table__content__row">
              <td
                [ngClass]="'color-property-' + property"
                class="company-comparison__tables__table__content__row__property-cell"
              >
                <div class="company-comparison__tables__table__content__row__property-cell__title">
                  <span>
                    <ng-container *ngIf="!shouldDisplayTooltip.includes(property)">
                      {{
                        'COMPANY_COMPARISON.STATUS.' +
                          (tableName | changeCase: 'constantCase') +
                          '.' +
                          (property | changeCase: 'constantCase') | translate
                      }}
                    </ng-container>
                    <ng-container *ngIf="shouldDisplayTooltip.includes(property)">
                      {{
                        'COMPANY_COMPARISON.STATUS.' +
                          (tableName | changeCase: 'constantCase') +
                          '.' +
                          (property | changeCase: 'constantCase') +
                          '.TITLE' | translate
                      }}
                    </ng-container>
                  </span>
                  <mat-icon
                    *ngIf="shouldDisplayTooltip.includes(property)"
                    [matTooltip]="
                      'COMPANY_COMPARISON.STATUS.' +
                        (tableName | changeCase: 'constantCase') +
                        '.' +
                        (property | changeCase: 'constantCase') +
                        '.TOOLTIP' | translate
                    "
                    class="company-comparison__tables__table__content__row__property-cell__title__info-icon"
                  >
                    info_outline
                  </mat-icon>
                </div>
              </td>

              <ng-container *ngIf="!isLoadingAllData">
                <td
                  *ngFor="let company of selectedCompaniesWithTableData"
                  [ngClass]="'color-property-' + property"
                  class="company-comparison__tables__table__content__row__value-cell"
                >
                  <ng-container *ngIf="isPercentage.includes(property)">
                    {{ formatPercentageData(property, tableName, company) }}
                  </ng-container>
                  <ng-container *ngIf="shouldInFormatDurationSeconds.includes(property)">
                    {{ company.table[tableName][property] | formatDuration: 'seconds' }}
                  </ng-container>
                  <ng-container *ngIf="shouldInFormatDurationDays.includes(property)">
                    {{ company.table[tableName][property] | formatDuration: 'days' }}
                  </ng-container>
                  <ng-container *ngIf="shouldShowStars.includes(property)">
                    <div class="company-comparison__tables__table__content__row__value-cell__totalAverage">
                      <span
                        class="company-comparison__tables__table__content__row__value-cell__totalAverage__text"
                        [ngClass]="{ 'good-rating': company.table[tableName][property] >= 3 }"
                      >
                        {{ company.table[tableName][property] }}
                      </span>
                      <stars
                        [rating]="company.table[tableName][property]"
                        [color]="company.table[tableName][property] >= 3 ? '#2FB688' : '#F6474C'"
                      ></stars>
                    </div>
                  </ng-container>
                  <ng-container
                    *ngIf="
                      !shouldInFormatDurationSeconds.includes(property) &&
                      !shouldInFormatDurationDays.includes(property) &&
                      !isPercentage.includes(property) &&
                      !shouldShowStars.includes(property)
                    "
                  >
                    {{ company.table[tableName][property] }}
                  </ng-container>
                </td>
              </ng-container>

              <ng-container *ngIf="isLoading || isLoadingAllData">
                <ngx-skeleton-loader
                  *ngFor="let skeletonColumn of skeletonColumnsQuantityWhenAlreadySomeDataLoaded"
                  [theme]="{ width: '100%', height: '100%', margin: '0px' }"
                >
                </ngx-skeleton-loader>
              </ng-container>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </ng-container>
  </div>
</div>
